import React, { useState } from 'react';
import { TextBox, TextBoxLayoutStyle } from '@apply/components';
import { CustomRule } from 'devextreme-react/validator';

export const TextBoxPanel: React.FC = () => {
    // State for each example
    const [basicValue, setBasicValue] = useState('');
    const [readOnlyValue, setReadOnlyValue] = useState('Read only value');
    const [requiredValue, setRequiredValue] = useState('');
    const [customValue, setCustomValue] = useState('');

    // Custom validator: value must include the word "test"
    const customValidator = (
        <CustomRule
            message="Value must include 'test'"
            validationCallback={(e: any) => {
                if (!e.value) return true; // Consider empty valid, or adjust as needed.
                return e.value.includes('test');
            }}
        />
    );

    return (
        <>
            {/* Example 1: Basic TextBox */}
            <div style={{ marginBottom: '1rem' }}>
                <TextBox
                    value={basicValue}
                    onChange={setBasicValue}
                    label='Basic TextBox'
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <TextBox
                    value={basicValue}
                    onChange={setBasicValue}
                    label='Basic TextBox with Info Bubble Popup'
                    showInfoIcon={true}
                    infoText='This is some text.'
                />
            </div>
            {/* Example 2: Read-Only TextBox */}
            <div style={{ marginBottom: '1rem' }}>
                <TextBox
                    value={readOnlyValue}
                    onChange={setReadOnlyValue}
                    label='Read-Only TextBox'
                    readOnly={true}
                />
            </div>

            {/* Example 3: Required Field */}
            <div style={{ marginBottom: '1rem' }}>
                <TextBox
                    value={requiredValue}
                    onChange={setRequiredValue}
                    label='Required TextBox'
                    required={true}
                />
            </div>

            {/* Example 4: Custom Validator */}
            <div style={{ marginBottom: '1rem' }}>
                <TextBox
                    value={customValue}
                    onChange={setCustomValue}
                    label='Custom Validator TextBox With Helper Text'
                    helperText="Helper Text: Entry must include the word 'test'."
                    validator={customValidator}
                />
            </div>
            {/* Example 5: Basic TextBox - Horizontal */}
            <div style={{ marginBottom: '1rem' }}>
                <TextBox
                    value={basicValue}
                    onChange={setBasicValue}
                    label='Basic TextBox (Horiz.)'
                    layoutStyle={TextBoxLayoutStyle.Horizontal}
                    labelWidth='150px'
                />
            </div>
            {/* Example 5: Basic TextBox - Horizontal with bubble */}
            <div style={{ marginBottom: '1rem' }}>
                <TextBox
                    value={basicValue}
                    onChange={setBasicValue}
                    label='Basic TextBox (Horiz.)'
                    layoutStyle={TextBoxLayoutStyle.Horizontal}
                    showInfoIcon={true}
                    infoText='This is some text.'
                    labelWidth='170px'
                />
            </div>
        </>
    );
};
